<div class="carousel-container">
  <div class="carousel">
    <div
      class="carousel-list"
      #carouselListRef
    >
      <div
        class="carousel-track"
        #carouselTrackRef
      >
        @for (carouselItem of carouselItems(); track $index) {
          @if (carouselItem.slug) {
            <a
              class="carousel-slide carousel-item"
              [class.carousel-slide-framed]="slideAspectRatio()"
              [style.width.%]="carouselItemWidth()"
              [style.aspect-ratio]="slideAspectRatio()"
              [routerLink]="'/' + carouselItem.slug"
              routerLinkWithLang
              (touchstart)="swipe($event, 'start')"
              (touchend)="swipe($event, 'end')"
              (click)="onMediaClick($index)"
            >
              <ng-container *ngTemplateOutlet="slideContentTmpl"></ng-container>
            </a>
          } @else {
            <div
              class="carousel-slide carousel-item"
              [class.carousel-slide-framed]="slideAspectRatio()"
              [style.width.%]="carouselItemWidth()"
              [style.aspect-ratio]="slideAspectRatio()"
              (touchstart)="swipe($event, 'start')"
              (touchend)="swipe($event, 'end')"
              (click)="onMediaClick($index)"
              >
              <ng-container *ngTemplateOutlet="slideContentTmpl"></ng-container>
            </div>
          }
          <ng-template #slideContentTmpl>
            <img
              class="carousel-item-img"
              [src]="getMediaUrl(carouselItem)"
              loading="lazy"
              alt="img"
            >
            @if (showPrice()) {
              @if (carouselItem?.price && !carouselItem?.oldPrice) {
                <div
                  class="carousel-item-sale-label sale-label"
                  >
                  <span class="sale-label-price sale-label-price-black">{{ carouselItem?.price }} грн</span>
                </div>
              }
              @if (carouselItem?.oldPrice) {
                <div
                  class="carousel-item-sale-label sale-label"
                  >
                  <span class="sale-label-old-price">{{ carouselItem?.oldPrice }} грн</span>
                  <span class="sale-label-price sale-label-price-red">{{ carouselItem?.price }} грн</span>
                </div>
              }
            }
            @if (showDiscount() && carouselItem.oldPrice) {
              <span class="sale-label-discount">
                -{{ carouselItem?.discountValue }}%
              </span>
            }
            @if (showLabel() && carouselItem.label) {
              <span
                class="carousel-item-label"
                [ngClass]="getLabelClass(carouselItem)"
                >
                {{ carouselItem.label.text }}
              </span>
            }
          </ng-template>
        }

      </div>
    </div>
  </div>

  @if (showThumbnails()) {
    @if (carouselItems().length > 1) {
      <div
        class="carousel-thumbnails"
      >
        @for (carouselItem of carouselItems(); track $index) {
          @let userFriendlyIndex = $index + 1;
          @let fullAltText = mediaAltText() + ' - ' + ('global.image' | translate) + ' ' + userFriendlyIndex;

          <img
            class="carousel-thumbnail"
            [class.carousel-thumbnail-active]="activeSlideIndex() === $index"
            [src]="carouselItem.media.variantsUrls.small"
            [alt]="mediaAltText() ? fullAltText : undefined"
            (click)="onMediaClick($index)"
            loading="lazy"
            #thumbnailItemRef
          >
        }
      </div>
    }
  }
</div>
